export default "__VITE_ASSET__DdzyZD90__"